import ServiceWorkerUpdatePopup from '@/pwa/components/service-worker-update-popup.vue';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: {
    ServiceWorkerUpdatePopup
  }
})
export default class App extends Vue {}
